export enum ConnectorNameEnum {
  BSC = 'bsc',
  MetaMask = 'metaMask',
  Injected = 'injected',
  WalletConnectNoQrCode = 'WalletConnectNoQrCode',
  WalletConnect = 'walletConnect',
  TrustWallet = 'trustWallet',
}
